/**
 * German translations for Okulus Photography Platform
 */
export const de = {
  common: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    search: "Suchen",
    filter: "Filtern",
    loading: "Lädt...",
    error: "Fehler",
    success: "Erfolg",
    confirm: "Bestätigen",
    close: "Schließen",
    back: "Zurück",
    configure: "Konfigurieren",
    configureTitle: "Einstellungen für {name}",
    configureDescription: "Speicher, Sprache und Firmendaten für diesen Benutzer festlegen.",
    storageTab: "Speicher",
    localizationTab: "Sprache",
    companyTab: "Firma",
    noUserSelected: "Kein Benutzer ausgewählt",
    loadingSettings: "Einstellungen werden geladen...",
    failedToLoadSettings: "Einstellungen konnten nicht geladen werden",
    storageProviderLabel: "Speicheranbieter",
    storageOptionLocal: "Lokaler Speicher",
    storageOptionR2: "Cloudflare R2",
    storageOptionB2: "Backblaze B2",
    storageOptionGcs: "Google Cloud Storage",
    storageLocalDescription: "Dateien verbleiben auf dem lokalen Server (nur für Tests empfohlen).",
    storageR2Description: "Cloudflare-R2-Zugangsdaten für Uploads und Downloads hinterlegen.",
    storageB2Description: "Backblaze-B2-Zugangsdaten für Uploads und Downloads hinterlegen.",
    storageGcsDescription: "Google-Cloud-Bucket und Service-Account JSON angeben.",
    timezoneLabel: "Zeitzone",
    timezoneHint: "z.B. Europe/Sarajevo",
    fields: {
      r2AccessKeyId: "Access Key ID",
      r2SecretAccessKey: "Secret Access Key",
      r2Endpoint: "Endpoint",
      r2BucketName: "Bucket-Name",
      b2KeyId: "Key ID",
      b2ApplicationKey: "Application Key",
      b2BucketName: "Bucket-Name",
      b2Endpoint: "Endpoint (optional)",
      b2Region: "Region",
      gcsProjectId: "Projekt-ID",
      gcsBucketName: "Bucket-Name",
      gcsCredentialsJson: "Service-Account JSON",
    },
    next: "Weiter",
    previous: "Zurück",
    upload: "Hochladen",
    download: "Herunterladen",
    downloaded: "Heruntergeladen",
    view: "Ansehen",
    video: "Video",
    print: "Druck",
    digital: "Digital",
    image: "Bild",
    actions: "Aktionen",
    status: "Status",
    date: "Datum",
    time: "Zeit",
    total: "Summe",
    price: "Preis",
    quantity: "Menge",
      storageSaved: "Speichereinstellungen gespeichert",
      storageFailed: "Speichereinstellungen fehlgeschlagen",
      localizationSaved: "Sprache aktualisiert",
      localizationFailed: "Sprache konnte nicht gespeichert werden",
      companySaved: "Firmendaten gespeichert",
      companyFailed: "Firmendaten konnten nicht gespeichert werden",
    yes: "Ja",
    no: "Nein",
    page: "Seite",
    of: "von",
    showing: "Zeige",
    refresh: "Aktualisieren",
    saving: "Speichert...",
    optional: "Optional",
    backToGallery: "Zurück zur Galerie",
  },

  auth: {
    login: "Anmelden",
    logout: "Abmelden",
    register: "Registrieren",
    email: "Email",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    resetPassword: "Passwort zurücksetzen",
    welcomeBack: "Willkommen zurück",
    signIn: "Anmelden",
    signOut: "Abmelden",
      pleaseLoginToContinue: "Bitte melden Sie sich an, um fortzufahren",
    notRegistered: "Nicht registriert?",
    alreadyHaveAccount: "Bereits ein Konto?",
    loginSuccess: "Erfolgreich angemeldet!",
    registerSuccess: "Konto erfolgreich erstellt!",
    passwordResetSuccess: "Passwort erfolgreich geändert!",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordTooShortAuth: "Passwort muss mindestens 8 Zeichen lang sein",
    enterEmail: "Bitte geben Sie eine E-Mail-Adresse ein",
    accountNotActivated: "Konto ist nicht aktiviert. Bitte kontaktieren Sie den Administrator.",
  },

  nav: {
    dashboard: "Dashboard",
    projects: "Projekte",
    images: "Bilder",
    accessCodes: "Zugangscodes",
    orders: "Bestellungen",
    settings: "Einstellungen",
    gallery: "Galerie",
    cart: "Warenkorb",
    profile: "Profil",
    analytics: "Analytik",
    adminUsers: "Benutzer",
  },

  settings: {
    title: "Einstellungen",
    general: "Allgemein",
    security: "Sicherheit",
    system: "System",
    systemDescription: "Systemname und Basis-URL (global)",
    systemName: "Systemname",
    baseUrl: "Basis-URL",
    systemNameGlobalNote: "Dieser Wert ist global und kann nur zentral geändert werden.",
    baseUrlHelp: "Diese Basis-URL wird für QR-Codes und Links verwendet und gilt für alle Benutzer.",
    codeLoginLimit: "Maximale Logins pro Zugangscode",
    codeLoginLimitHelp: "Wie oft sich ein Zugangscode aus der PDF anmelden darf",
    maxManualDigitalImages: "Max. digitale Bilder (manueller Download)",
    maxManualDigitalImagesHelp: "Maximale Anzahl digitaler Bilder, die pro Login-Code ohne Paket ausgewählt werden können",
    maxManualDigitalImagesReached: "Maximale Anzahl digitaler Bilder erreicht",
    save: "Speichern",
    pricing: "Preise",
    shippingRates: "Versandkosten",
    shippingRatesTitle: "Versandkosten nach Land",
    shippingRatesDescription: "Konfigurieren Sie die Versandkosten für verschiedene Länder. Nur aktive Länder werden beim Checkout angeboten.",
    shippingRatesCountry: "Land",
    shippingRatesCost: "Kosten",
    shippingRatesActive: "Aktiv",
    shippingRatesActions: "Aktionen",
    shippingRatesAddButton: "Neues Land hinzufügen",
    shippingRatesAddTitle: "Neues Land hinzufügen",
    shippingRatesSelectPlaceholder: "Land wählen...",
    shippingRatesCustomPlaceholder: "Ländername eingeben",
    shippingRatesCustomOption: "Anderes Land...",
    shippingRatesCostInputLabel: "Versandkosten (€)",
    shippingRatesCostInputPlaceholder: "0.00",
    shippingRatesEmpty: "Noch keine Versandkosten konfiguriert",
    shippingRatesToastSaved: "Versandkosten gespeichert",
    shippingRatesToastDeleted: "Versandkosten gelöscht",
    shippingRatesToastErrorPrefix: "Fehler:",
    shippingRatesFormMissing: "Bitte Land und Kosten eingeben",
    shippingRatesDeleteConfirm: "Versandkosten wirklich löschen?",
    shippingRatesCountryOptions: [
      "Deutschland",
      "Österreich",
      "Schweiz",
      "Bosnien und Herzegowina",
      "Kroatien",
      "Serbien",
      "Montenegro",
      "Slowenien",
      "Nordmazedonien",
    ],
    watermark: "Wasserzeichen",
    paypal: "PayPal",
    storage: "Speicher",
    gallery: "Galerie",
    qrCode: "QR-Code",
    notifications: "Benachrichtigungen",
    localization: "Lokalisierung",
    legal: "Rechtliches",
    legalTab: {
      title: "Rechtsseiten",
      description: "Impressum, Datenschutz, Versand und weitere Footer-Inhalte.",
      createButton: "Neue Seite",
      defaultsButton: "Standardseiten",
      emptyState: "Keine Seiten vorhanden.",
      inactiveBadge: "inaktiv",
      validationError: "Bitte alle Felder ausfüllen",
      deleteConfirm: "Diese Seite löschen?",
      toastCreated: "Seite erstellt",
      toastUpdated: "Seite aktualisiert",
      toastDeleted: "Seite gelöscht",
      defaultsAlready: "Standardseiten sind bereits vorhanden",
      defaultsCreated: "Standardseiten angelegt",
      defaultsFailed: "Anlegen der Standardseiten ist fehlgeschlagen",
      defaultContentNote: "Inhalt kann in Einstellungen › Legal angepasst werden.",
      dialog: {
        createTitle: "Neue Seite",
        editTitle: "Seite bearbeiten",
        description: "Slug wird in der URL verwendet. Inhalt kann HTML enthalten.",
        slugLabel: "Slug",
        titleLabel: "Titel",
        sortOrderLabel: "Sortierung",
        activeLabel: "Aktiv",
        languageLabel: "Sprache",
        contentLabel: "Inhalt ({lang})",
        slugPlaceholder: "impressum",
        titlePlaceholder: "Impressum",
      },
      buttons: {
        cancel: "Abbrechen",
        save: "Speichern",
        saving: "Speichern...",
      },
      defaultPages: {
        impressum: "Impressum",
        privacy: "Datenschutz",
        terms: "Nutzungsbedingungen",
        contact: "Kontakt",
        shipping: "Versand",
        payment: "Zahlungsarten",
      },
    },

    pricePerImage: "Preis pro Bild",
    pricePerVideo: "Preis pro Video",
    currency: "Währung",

    watermarkEnabled: "Wasserzeichen aktivieren",
    watermarkText: "Wasserzeichen-Text",
    watermarkLogo: "Wasserzeichen-Logo",
    watermarkPosition: "Position des Wasserzeichens",
    watermarkOpacity: "Deckkraft des Wasserzeichens",
    center: "Mitte",
    topLeft: "Oben links",
    topRight: "Oben rechts",
    bottomLeft: "Unten links",
    bottomRight: "Unten rechts",
    tiled: "Gekachelt",

    paypalMode: "PayPal-Modus",
    sandbox: "Sandbox (Test)",
    live: "Live (Produktion)",
    paypalClientId: "PayPal Client ID",
    paypalClientSecret: "PayPal Client Secret",

    gcs: "Cloudflare R2",
    gcsProjectId: "R2 Access Key ID",
    gcsBucketName: "R2 Bucket Name",
    gcsCredentials: "R2 Secret Access Key",

    settingsSaved: "Einstellungen gespeichert",
    settingsFailed: "Speichern der Einstellungen fehlgeschlagen",

    language: "Sprache",
    timezone: "Zeitzone",
    dateFormat: "Datumsformat",

    pleaseLogin: "Bitte melden Sie sich an",
    pricingDescription: "Konfigurieren Sie Preise für Bilder",
    watermarkDescription: "Konfigurieren Sie Wasserzeichen für Bilder",
    gcsDescription: "Cloudflare R2 für Bilder konfigurieren",
    r2Title: "Cloudflare R2",
    r2Description: "Cloudflare R2 Speicher für Bilder konfigurieren",
    r2AccessKeyId: "R2 Access Key ID",
    r2SecretAccessKey: "R2 Secret Access Key",
    r2Endpoint: "R2 Endpoint (accountid.r2.cloudflarestorage.com)",
    r2BucketName: "R2 Bucket Name",
    r2TestConnection: "R2 Verbindung testen",
    r2TestSuccess: "R2 Verbindung erfolgreich",
    r2TestFailed: "R2 Verbindung fehlgeschlagen",
    r2FetchUsage: "Speichernutzung abrufen",
    r2UsageLabel: "Bucket Nutzung",
    r2UsageObjects: "Objekte",
    r2UsageBytes: "Gesamtgröße",
    r2UsageFailed: "Nutzung konnte nicht abgerufen werden",
    localizationDescription: "Wählen Sie die Sprache der Oberfläche",
    downloadLinkDays: "Gültigkeit des Download-Links (Tage)",
    downloadLinkDaysHelp: "Wie lange Kunden den ZIP-Download nutzen können",
    emailNotificationsEnabled: "E-Mail-Benachrichtigungen aktivieren",
    notificationEmail: "Benachrichtigungs-E-Mail",
    smtpPassword: "SMTP-Passwort",
    paypalDescription: "PayPal für Zahlungen konfigurieren",
    emailNotifications: "E-Mail-Benachrichtigungen",
    emailNotificationsDescription: "SMTP-Server für E-Mail-Benachrichtigungen konfigurieren",
    enableEmailNotifications: "E-Mail-Benachrichtigungen aktivieren",
    manageDescription: "Verwalten Sie Ihre Plattform-Einstellungen",
    smtpSettings: "SMTP-Einstellungen",
    smtpHost: "SMTP-Host",
    smtpPort: "SMTP-Port",
    smtpUser: "SMTP-Benutzer",
    smtpFrom: "Absender-E-Mail",
    smtpTestConnection: "SMTP testen",
    smtpTestSuccess: "SMTP Test-E-Mail gesendet",
    smtpTestFailed: "SMTP Test fehlgeschlagen",
    smtpTestRecipient: "Test Empfänger",
    sendInvoiceEmail: "Automatisch Rechnung per E-Mail versenden",
      companyInfo: "Firma / Rechnungen",
      companyInfoDescription: "Firmendaten für Rechnungen und rechtliche Dokumente speichern",
      companyName: "Firmenname",
      companyAddressLine1: "Adresse Zeile 1",
      companyAddressLine2: "Adresse Zeile 2",
      companyPostalCode: "PLZ",
      companyCity: "Stadt",
      companyCountry: "Land",
      companyVatId: "USt-IdNr.",
      companyTaxNumber: "Steuernummer",
      companyTaxRate: "Steuersatz (%)",
      companyEmail: "Firma E-Mail",
      companyPhone: "Firma Telefon",
      companyWebsite: "Webseite",
      companyBankName: "Bankname",
      companyIban: "IBAN",
      companySwift: "SWIFT/BIC",
      companyLogoGcsKey: "Logo Speicher Key",
      companyLogoUploadLabel: "Firmenlogo hochladen",
      companyLogoUploadButton: "Logo hochladen",
      companyLogoPreview: "Aktuelles Logo",
      companyLogoNoFile: "Kein Logo ausgewählt",
      companyInvoiceFooter: "Rechnungsfuß Notizen",
    placeholders: {
      pricePerImage: "5.00",
      pricePerVideo: "10.00",
      watermarkText: "Photography",
      companyName: "Meine Firma GmbH",
      companyVatId: "DE123456789",
      companyTaxNumber: "123/456/78901",
      companyTaxRate: "19.00",
      companyAddressLine1: "Straße 1",
      companyAddressLine2: "Etage / Zusatz",
      companyPostalCode: "12345",
      companyCity: "Berlin",
      companyCountry: "Deutschland",
      companyEmail: "info@firma.de",
      companyPhone: "+49 30 123456",
      companyWebsite: "https://www.firma.de",
      companyBankName: "Bankname",
      companyIban: "DE89 3704 0044 0532 0130 00",
      companySwift: "COBADEFFXXX",
      companyLogoGcsKey: "logo/pfad.png",
      companyInvoiceFooter: "Zusätzliche Hinweise für Rechnungen",
      paypalClientId: "PayPal Client ID",
      paypalClientSecret: "PayPal Client Secret",
      r2AccessKeyId: "ACCESS_KEY_ID",
      r2SecretAccessKey: "SECRET_ACCESS_KEY",
      r2Endpoint: "accountid.r2.cloudflarestorage.com",
      r2BucketName: "bucket-name",
      smtpHost: "smtp.gmail.com",
      smtpPort: "587",
      smtpUser: "benutzer@gmail.com",
      smtpPassword: "passwort",
      smtpFrom: "noreply@beispiel.de",
      smtpTestRecipient: "empfaenger@beispiel.de",
      notificationEmail: "name@beispiel.de",
    },
    storageMonitoring: "Speicher-Monitoring",
    storageMonitoringDescription: "Überwachen Sie Ihre Upload-Speichernutzung",
    storageProviderTitle: "Speicher-Anbieter",
    storageProviderDescription: "Konfigurieren Sie, wo Originale und Vorschauen abgelegt werden.",
    storageProviderLabel: "Anbieter",
    storageProviderPlaceholder: "Speicher auswählen",
    storageProviderHelp: "Cloud-Speicher schützt Uploads vor Datenverlust bei Deployments.",
    localStorageWarningTitle: "Lokaler Speicher nur für Tests",
    localStorageWarning: "Uploads liegen auf dem App-Server und werden bei jedem Deployment gelöscht. Nutzen Sie R2 oder GCS für den Live-Betrieb.",
    useLocalStorage: "Auf lokalen Speicher wechseln",
    storageUsed: "Verwendet",
    storageRemaining: "Verfügbar",
    storageUsagePercent: "Auslastung",
    storageLimit: "Limit",
    storageOverLimit: "Speicherlimit überschritten!",
    storageOverLimitMessage: "Bitte erhöhen Sie das Limit oder löschen Sie Dateien.",
    storageNearLimit: "Speicher fast voll",
    storageNearLimitMessage: "Erwägen Sie, das Limit zu erhöhen.",
    configureStorageLimit: "Speicherlimit konfigurieren",
    storageLimitGB: "Limit (GB)",
    storageLimitHelp: "Setzen Sie das maximale Speicherlimit für Uploads in Gigabyte.",
    currentLimit: "Aktuelles Limit",
    storageLoadError: "Fehler beim Laden der Speicherinformationen",
    storageLimitUpdated: "Speicherlimit aktualisiert",
    storageLimitPasswordTitle: "Super-Passwort erforderlich",
    storageLimitPasswordDescription: "Geben Sie das Super-Passwort ein, um das Speicherlimit zu ändern.",
    password: "Passwort",
    passwordCorrect: "Zugriff gewährt",
    passwordIncorrect: "Falsches Passwort",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordMismatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",
    currentPasswordRequired: "Aktuelles Passwort erforderlich",
    changeSuperPassword: "Super-Passwort ändern",
    changeSuperPasswordDesc: "Ändern Sie das Passwort, das zum Schutz sensibler Einstellungen verwendet wird.",
    twoFactorAuth: "Zwei-Faktor-Authentifizierung",
    twoFactorAuthDescription: "Erhöhen Sie die Sicherheit Ihres Kontos mit 2FA",
    twoFactorEnabled: "2FA ist aktiviert",
    twoFactorDisabled: "2FA ist deaktiviert",
    twoFactorProtected: "Ihr Konto ist durch 2FA geschützt",
    twoFactorNotProtected: "Aktivieren Sie 2FA für zusätzliche Sicherheit",
    twoFactorBackupCodes: "Backup-Codes",
    twoFactorBackupCodesRemaining: "{count} ungenutzte Codes verfügbar",
    twoFactorGenerateNew: "Neue generieren",
    twoFactorImportantNote: "Wichtiger Hinweis",
    twoFactorAuthenticatorNote: "Verwenden Sie eine Authenticator-App wie Google Authenticator, Microsoft Authenticator oder Authy, um Ihre 2FA-Codes zu generieren.",
    twoFactorEnableTitle: "Zwei-Faktor-Authentifizierung aktivieren",
    twoFactorEnableDescription: "Scannen Sie den QR-Code mit Ihrer Authenticator-App",
    twoFactorManualCode: "Oder geben Sie diesen Code manuell ein:",
    twoFactorVerificationCode: "Bestätigungscode aus Ihrer App",
    twoFactorVerificationCodePlaceholder: "123456",
    twoFactorDisableTitle: "Zwei-Faktor-Authentifizierung deaktivieren",
    twoFactorDisableDescription: "Geben Sie Ihr Passwort ein, um 2FA zu deaktivieren",
    twoFactorDisableWarning: "⚠️ Warnung: Das Deaktivieren von 2FA verringert die Sicherheit Ihres Kontos.",
    twoFactorBackupCodesTitle: "Ihre Backup-Codes",
    twoFactorBackupCodesDescription: "Speichern Sie diese Codes an einem sicheren Ort. Jeder Code kann nur einmal verwendet werden.",
    twoFactorBackupCodesCopyAll: "Alle Codes kopieren",
    twoFactorBackupCodesImportant: "⚠️ Wichtig: Diese Codes werden nur einmal angezeigt. Speichern Sie sie sicher!",
    twoFactorBackupCodesSaved: "Ich habe die Codes gespeichert",
    twoFactorLoginTitle: "Zwei-Faktor-Authentifizierung",
    twoFactorLoginDescription: "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein",
    twoFactorLoginCode: "2FA-Code",
    twoFactorLoginCodePlaceholder: "123456",
    twoFactorLoginBackupHint: "Sie können auch einen Backup-Code verwenden",
    twoFactorLoginVerify: "Verifizieren",
    twoFactorLoginBack: "Zurück zum Login",
    twoFactorEnterCode: "Bitte geben Sie Ihren 2FA-Code ein",
    twoFactorInvalidCode: "Ungültiger 2FA-Code",
    twoFactorActivated: "Zwei-Faktor-Authentifizierung aktiviert!",
    twoFactorDeactivated: "Zwei-Faktor-Authentifizierung deaktiviert",
    twoFactorBackupCodesGenerated: "Neue Backup-Codes generiert",
    twoFactorCodeCopied: "In Zwischenablage kopiert",
    twoFactorAllCodesCopied: "Alle Backup-Codes kopiert",
  },

  printFormats: {
    title: "Druckformate",
    newFormat: "Neues Format",
    editFormat: "Format bearbeiten",
    noFormatsMessage: "Keine Formate definiert. Erstellen Sie Ihr erstes Format.",
    dialogDescription: "Definieren Sie die Eigenschaften des Druckformats",
    name: "Name",
    width: "Breite",
    height: "Höhe",
    unit: "Einheit",
    price: "Preis ({currency})",
    active: "Aktiv",
    cancel: "Abbrechen",
    save: "Speichern",
    deleteConfirm: "Format wirklich löschen?",
    created: "Format erstellt",
    updated: "Format aktualisiert",
    deleted: "Format gelöscht",
    namePlaceholder: "z.B. 10x15 cm Standard",
    passwordCorrect: "Zugriff gewährt",
    passwordIncorrect: "Falsches Passwort",
  },

  adminUsers: {
    title: "Benutzerverwaltung",
    back: "Zurück",
    searchPlaceholder: "Suche (E-Mail/Name)",
    createTitle: "Neuen Benutzer erstellen",
    email: "E-Mail",
    name: "Name",
    password: "Passwort",
    role: "Rolle",
    roleUser: "Benutzer",
    roleAdmin: "Admin",
    active: "Aktiv",
    create: "Erstellen",
    listTitle: "Benutzerliste",
    configure: "Konfigurieren",
    configureTitle: "Einstellungen für {name}",
    configureDescription: "Speicheranbieter, Sprache und Firmendaten für diesen Benutzer zuweisen.",
    storageTab: "Speicher",
    localizationTab: "Sprache",
    companyTab: "Firma",
    noUserSelected: "Kein Benutzer ausgewählt",
    loadingSettings: "Lade Einstellungen...",
    failedToLoadSettings: "Einstellungen konnten nicht geladen werden",
    storageProviderLabel: "Speicheranbieter",
    storageOptionLocal: "Lokale Uploads",
    storageOptionR2: "Cloudflare R2",
    storageOptionB2: "Backblaze B2",
    storageOptionGcs: "Google Cloud Storage",
    storageLocalDescription: "Dateien verbleiben auf dem Server (nur für Demos empfohlen).",
    storageR2Description: "Geben Sie die Cloudflare-R2-Zugangsdaten für Uploads/Downloads an.",
    storageB2Description: "Geben Sie die Backblaze-B2-Zugangsdaten für Uploads/Downloads an.",
    storageGcsDescription: "Geben Sie den Google-Cloud-Bucket und das Servicekonto an.",
    timezoneLabel: "Zeitzone",
    timezoneHint: "Beispiel: Europe/Berlin",
    fields: {
      r2AccessKeyId: "Access Key ID",
      r2SecretAccessKey: "Secret Access Key",
      r2Endpoint: "Endpoint",
      r2BucketName: "Bucket-Name",
      b2KeyId: "Key ID",
      b2ApplicationKey: "Application Key",
      b2BucketName: "Bucket-Name",
      b2Endpoint: "Endpoint (optional)",
      b2Region: "Region",
      gcsProjectId: "Project ID",
      gcsBucketName: "Bucket-Name",
      gcsCredentialsJson: "Service-Account JSON",
    },
    actions: "Aktionen",
    delete: "Löschen",
    noneFound: "Keine Benutzer gefunden",
    activateUser: "Benutzer aktivieren",
    activateUserDescription: "Weisen Sie dem Benutzer eine Speicher-Quota zu, bevor Sie ihn aktivieren.",
    storageQuota: "Speicher-Quota",
    storageQuotaHelp: "Empfohlen: 50GB für normale Benutzer",
    activate: "Aktivieren",
    toasts: {
      created: "Benutzer erstellt",
      updated: "Benutzer aktualisiert",
      deleted: "Benutzer gelöscht",
      createFailed: "Erstellung fehlgeschlagen",
      updateFailed: "Aktualisierung fehlgeschlagen",
      activateFailed: "Aktivierung fehlgeschlagen",
      roleFailed: "Rollenänderung fehlgeschlagen",
      deleteFailed: "Löschen fehlgeschlagen",
      storageSaved: "Speichereinstellungen gespeichert",
      storageFailed: "Speichereinstellungen konnten nicht gespeichert werden",
      localizationSaved: "Spracheinstellungen gespeichert",
      localizationFailed: "Spracheinstellungen konnten nicht gespeichert werden",
      companySaved: "Firmendaten gespeichert",
      companyFailed: "Firmendaten konnten nicht gespeichert werden",
    },
  },

  analytics: {
    title: "Analytik",
    subtitle: "Leistungsübersicht und Statistiken",
    pleaseLogin: "Bitte melden Sie sich an, um auf die Analytik zuzugreifen.",
    totalRevenue: "Gesamtumsatz",
    fromOrders: "Aus {count} Bestellungen",
    orders: "Bestellungen",
    paidOrders: "Bezahlte Bestellungen",
    conversion: "Konversion",
    codesUsed: "{converted} / {total} Codes",
    projects: "Projekte",
    imagesCount: "{count} Bilder",
    revenueByMonth: "Umsatz nach Monaten",
    last12Months: "Letzte 12 Monate",
    topProjects: "Top Projekte",
    top5Projects: "Top 5 Projekte nach Umsatz",
    revenueLabel: "Umsatz ({currency})",
  },

  systemLogs: {
    title: "System-Logs",
    subtitle: "Alle System-Aktivitäten und API-Aufrufe",
    filters: "Filter & Suche",
    refresh: "Aktualisieren",
    searchPlaceholder: "Suche nach Benutzer, Aktion, Details...",
    allActions: "Alle Aktionen",
    actions: {
      orderCreate: "Bestellung erstellt",
      orderUpdate: "Bestellung aktualisiert",
      projectCreate: "Projekt erstellt",
      imageUpload: "Bild hochgeladen",
      userLogin: "Benutzer-Anmeldung",
      userLogout: "Benutzer-Abmeldung",
      paymentSuccess: "Zahlung erfolgreich",
      paymentFailed: "Zahlung fehlgeschlagen",
    },
    allLevels: "Alle Ebenen",
    levels: {
      info: "Info",
      warning: "Warnung",
      error: "Fehler",
      success: "Erfolg",
    },
    clear: "Zurücksetzen",
    found: "{count} Einträge gefunden",
    pageOf: "Seite {page} von {total}",
    columns: {
      timestamp: "Zeitstempel",
      level: "Ebene",
      action: "Aktion",
      user: "Benutzer",
      details: "Details",
      ip: "IP",
    },
    noneFound: "Keine Logs gefunden",
  },

  dashboard: {
    welcomeBack: "Willkommen zurück",
    pleaseLogin: "Bitte melden Sie sich an, um auf das Dashboard zuzugreifen.",
    manage: "Verwalten Sie Ihre Fotoprojekte, verfolgen Sie Verkäufe und analysieren Sie die Performance.",
    myProjects: "Meine Projekte",
    quickStats: "Schnellstatistik",
    totalProjects: "Projekte gesamt",
    totalImages: "Bilder gesamt",
    totalOrders: "Bestellungen gesamt",
    totalRevenue: "Gesamtumsatz",
    quickActions: "Schnellaktionen",
    createProject: "Neues Projekt erstellen",
    viewAnalytics: "Analytik anzeigen",
    manageSettings: "Einstellungen verwalten",
    recentActivity: "Letzte Aktivitäten",
    recentProjects: "Letzte Projekte",
    allProjects: "Alle Projekte",
    noProjectsTitle: "Keine Projekte",
    noProjectsDescription: "Beginnen Sie mit der Erstellung Ihres ersten Fotoprojekts und verkaufen Sie Bilder.",
    createFirstProject: "Erstes Projekt erstellen",
    manageSettingsDescription: "Einstellungen konfigurieren",
  },

  projects: {
    title: "Projekte",
    createProject: "Projekt erstellen",
    editProject: "Projekt bearbeiten",
    deleteProject: "Projekt löschen",
    projectName: "Projektname",
    projectNumber: "Projektnummer",
    projectDescription: "Projektbeschreibung",
    projectStatus: "Projektstatus",
    draft: "Entwurf",
    active: "Aktiv",
    archived: "Archiviert",
    totalImages: "Bilder gesamt",
    totalCodes: "Codes gesamt",
    totalViews: "Aufrufe gesamt",
    createdAt: "Erstellt",
    updatedAt: "Aktualisiert",
    selectAvatar: "Avatar auswählen",
    noProjects: "Keine Projekte",
    createFirstProject: "Erstellen Sie Ihr erstes Projekt",
    confirmDelete: "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?",
    projectDeleted: "Projekt gelöscht",
    projectCreated: "Projekt erstellt",
    projectUpdated: "Projekt aktualisiert",
    backToDashboard: "Zurück zum Dashboard",
    projectsCount: "{count} Projekt | {count} Projekte",
    noDescription: "Keine Beschreibung",
    viewImages: "Bilder anzeigen",
    viewVideos: "Videos anzeigen",
    viewCodes: "Zugangscodes",
    editButton: "Bearbeiten",
    deleteButton: "Löschen",
  },

  orders: {
    title: "Bestellungen",
    orderNumber: "Bestellnummer",
    orderDate: "Bestelldatum",
    orderStatus: "Bestellstatus",
    pending: "Ausstehend",
    paid: "Bezahlt",
    failed: "Fehlgeschlagen",
    refunded: "Erstattet",
    shipped: "Versendet",
    customerName: "Kundenname",
    customerEmail: "Kunden-Email",
    totalAmount: "Gesamtbetrag",
    totalOrders: "Bestellungen gesamt",
    items: "Artikel",
    viewOrder: "Bestellung anzeigen",
    noOrders: "Keine Bestellungen",
    orderDetails: "Bestelldetails",
    orderInfo: "Bestellinformationen",
    paymentDetails: "Zahlungsdetails",
    transactionId: "Transaktions-ID",
    paymentMethod: "Zahlungsmethode",
    paymentStatus: "Status",
    downloadAll: "Alle Bilder herunterladen",
    download: "Herunterladen",
    image: "Bild",
    imagesAvailableAfterPayment: "Bilder stehen nach erfolgreicher Zahlung zum Download bereit.",
    imageCount: "Bild",
    imageCountPlural: "Bilder",
    ordersDescription: "Übersicht aller Bestellungen aus Ihren Projekten",
    project: "Projekt",
    shipping: "Versand",
    shippingDetails: "Versanddetails",
    shippingAddress: "Versandadresse",
    shippingOverview: "Versandübersicht",
    manageShipping: "Versand für Bestellung mit Druckartikeln verwalten",
    printItems: "Druckartikel",
    printItemsTotal: "Druckartikel Gesamt",
    loadingOrder: "Bestelldetails werden geladen...",
    orderNotFound: "Bestellung nicht gefunden.",
    noOrderSelected: "Keine Bestellung ausgewählt.",
    noPrintItems: "Diese Bestellung enthält keine zu versendenden Druckartikel.",
    printShippingLabel: "Versandetikett drucken",
    markAsShipped: "Als versendet markieren",
    viewFullOrder: "Vollständige Bestellung anzeigen",
    backToOrders: "Zurück zu Bestellungen",
    requiresShipping: "Versand",
    delivery: "Lieferung",
    pickup: "Abholung",
    shippingLabel: "VERSANDETIKETT",
    shipTo: "LIEFERADRESSE:",
    packageContents: "PAKETINHALT",
    printLabel: "Etikett drucken",
    deliveryNote: "Lieferschein",
    standardPrint: "Standarddruck",
    cancelled: "Storniert",
    cancelOrder: "Bestellung stornieren",
    orderCancelled: "Bestellung erfolgreich storniert",
    confirmCancel: "Möchten Sie diese Bestellung wirklich stornieren? Diese Aktion kann nicht rückgängig gemacht werden.",
    filters: "Filter",
    filtered: "gefiltert",
    searchPlaceholder: "Suche nach Bestellnummer, Name oder E-Mail...",
    allStatuses: "Alle Status",
    allProjects: "Alle Projekte",
    clearFilters: "Filter löschen",
    downloaded: "Heruntergeladen",
    downloadedAt: "Heruntergeladen am",
    notDownloadedYet: "Noch nicht heruntergeladen",
    markAsPaid: "Als bezahlt markieren",
    markingAsPaid: "Wird als bezahlt markiert...",
    markedAsPaid: "Bestellung erfolgreich als bezahlt markiert",
    downloadInvoice: "Rechnung herunterladen",
    noInvoice: "Keine Rechnung vorhanden",
    invoiceDownloaded: "Rechnung heruntergeladen",
  },

  cart: {
    title: "Warenkorb",
    emptyCart: "Ihr Warenkorb ist leer",
    continueShopping: "Weiter einkaufen",
    itemRemoved: "Artikel aus Warenkorb entfernt",
    cartUpdated: "Warenkorb aktualisiert",
    item: "Artikel",
    items: "Artikel",
    subtotal: "Zwischensumme",
    total: "Gesamt",
    proceedToCheckout: "Zur Kasse gehen",
    checkout: "Zur Kasse",
  },

  checkout: {
    title: "Kasse",
    customerInfo: "Kundeninformationen",
    customerInfoDesc: "Geben Sie Ihre Daten für die Bestellung ein",
    digitalDeliveryOnly: "Digitale Auslieferung – keine Adresse erforderlich.",
    name: "Name",
    namePlaceholder: "Vollständiger Name",
    email: "Email",
    emailPlaceholder: "ihre@email.com",
    addressLine1: "Adresse Zeile 1",
    addressLine1Placeholder: "Straße und Hausnummer",
    addressLine2: "Adresse Zeile 2",
    addressLine2Placeholder: "Wohnung / Suite (optional)",
    postalCode: "PLZ",
    postalCodePlaceholder: "Postleitzahl",
    city: "Stadt",
    cityPlaceholder: "Stadt",
    country: "Land",
    countryPlaceholder: "Land auswählen",
    phone: "Telefon",
    phonePlaceholder: "Telefonnummer",
    deliveryType: "Lieferart",
    homeDelivery: "Lieferung zur Adresse",
    selfPickup: "Abholung",
    billingAddress: "Rechnungsadresse",
    differentBillingAddress: "Abweichende Rechnungsadresse",
    billingAddressLine1: "Rechnungsadresse Zeile 1",
    billingAddressLine2: "Rechnungsadresse Zeile 2",
    billingPostalCode: "Rechnungs-PLZ",
    billingCity: "Rechnungsstadt",
    billingCountry: "Rechnungsland",
    shippingCost: "Versandkosten",
    shippingCostDesc: "Geben Sie die Versandkosten für physische Produkte ein.",
    paymentMethod: "Zahlungsmethode",
    orderSummary: "Bestellübersicht",
    payWithPayPal: "Sicher mit PayPal bezahlen",
    placeOrder: "Bestellung aufgeben",
    paymentSuccess: "Zahlung erfolgreich!",
    paymentFailed: "Zahlung fehlgeschlagen",
    pleaseEnterDetails: "Bitte geben Sie Ihre Daten ein",
    paypalNotConfigured: "PayPal ist nicht konfiguriert",
    thankYou: "Vielen Dank für Ihre Bestellung!",
    orderConfirmation: "Ihre Bestellung wurde erhalten und wird in Kürze bearbeitet.",
    downloadInstructions: "Sie erhalten eine Email mit Links zum Herunterladen Ihrer Bilder.",
    backToGallery: "Zurück zur Galerie",
    orderSuccess: "Bestellung erfolgreich!",
    orderSuccessDesc: "Ihre Bestellung wurde erfolgreich aufgegeben.",
    downloadInfoSent: "Download-Informationen wurden an Ihre E-Mail gesendet.",
    subtotal: "Zwischensumme",
    processing: "Verarbeitung läuft...",
    pickupAddress: "Abholung",
  },

  gallery: {
    alreadyPurchased: "Bereits gekauft",
    title: "Galerie",
    enterAccessCode: "Zugangscode eingeben",
    accessCode: "Zugangscode",
    projectNumber: "Projektnummer",
    login: "Anmelden",
    projectNotActiveTitle: "Galerie noch nicht verfügbar",
    projectNotActiveBody: "Hinterlassen Sie Ihre E-Mail und wir benachrichtigen Sie automatisch, sobald Inhalte veröffentlicht sind.",
    yourEmail: "Ihre E-Mail",
    emailPlaceholder: "sie@beispiel.de",
    notifyMe: "Benachrichtigen",
    notifySuccess: "Danke! Wir benachrichtigen Sie bei Veröffentlichung.",
    invalidCode: "Ungültiger Zugangscode",
    accessCodeLimitReached: "Zugangscode Limit erreicht",
    selectImages: "Bilder auswählen",
    addToCart: "In den Warenkorb",
    viewCart: "Warenkorb anzeigen",
    noImagesSelected: "Keine Bilder ausgewählt",
    scanQRCode: "Oder QR-Code scannen",
    scanInstruction: "Scannen Sie den QR-Code von Ihrer Karte",
    emptyGallery: "Noch keine Bilder oder Videos",
    selectProductType: "Produkttyp wählen",
    productType: "Produkttyp",
    digital: "Digital (Download)",
    print: "Druck (Physisches Foto)",
    selectFormat: "Format auswählen",
    loadingFormats: "Lade Formate...",
    noFormatsAvailable: "Keine Druckformate verfügbar. Bitte kontaktieren Sie den Fotografen.",
    addToCartButton: "Zum Warenkorb hinzufügen",
    logout: "Abmelden",
    sessionExpired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  },

  shop: {
    imprint: "Impressum",
    privacyPolicy: "Datenschutz",
    terms: "AGB",
    contact: "Kontakt",
    returns: "Rückgabe",
    shipping: "Versand",
    payment: "Zahlungsarten",
    footerDisclaimer: "Alle Preise inkl. gesetzl. MwSt. Änderungen vorbehalten.",
  },

  validation: {
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Ungültige Email-Adresse",
    passwordTooShort: "Passwort muss mindestens 8 Zeichen lang sein",
    passwordMismatch: "Passwörter stimmen nicht überein",
  },

  stats: {
    totalProjects: "Projekte gesamt",
    totalImages: "Bilder gesamt",
    totalOrders: "Bestellungen gesamt",
    totalRevenue: "Gesamtumsatz",
  },

  downloads: {
    title: "Downloads",
    errorTitle: "Download-Fehler",
    invalidOrExpiredLink: "Ungültiger oder abgelaufener Download-Link",
    enterOrderId: "Bestellnummer eingeben",
    orderIdLabel: "Bestellnummer",
    orderIdPlaceholder: "Bestellnummer eingeben",
    submit: "Absenden",
    invalidOrderNumber: "Ungültige Bestellnummer",
    allDownloaded: "Alle Bilder heruntergeladen!",
    downloadAll: "Alle herunterladen",
    download: "Herunterladen",
    orderNotFound: "Bestellung nicht gefunden oder Zugriff verweigert",
    noImages: "Keine Bilder für diese Bestellung verfügbar",
    downloadStarted: "Download gestartet für",
    downloadError: "Fehler beim Herunterladen",
    downloadFailed: "{filename} konnte nicht heruntergeladen werden",
    allDownloadsStarted: "Alle Downloads gestartet",
  },

  videos: {
    title: "Videos",
    videoDeleted: "Video gelöscht",
    downloadLinkError: "Download-Link konnte nicht erstellt werden",
    backToProject: "Zurück zum Projekt",
    uploadVideos: "Videos hochladen",
    selectFiles: "Dateien auswählen",
    maxFileSize: "Maximale Dateigröße: 15GB pro Video",
    dragDrop: "Videodateien hierher ziehen oder klicken Sie zum Auswählen",
    uploading: "Wird hochgeladen...",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    error: "Fehler",
    confirmDelete: "Sind Sie sicher, dass Sie dieses Video löschen möchten?",
    deleteVideo: "Video löschen",
    noVideos: "Keine Videos",
    uploadFirstVideo: "Laden Sie Ihr erstes Video hoch",
    uploadFailed: "Upload fehlgeschlagen",
  },

  legal: {
    contactTitle: "Kontakt",
    contactDefault: "Inhalt kann in Einstellungen › Legal angepasst werden.",
    impressumTitle: "Impressum",
    impressumDefault: "Test",
  },

  forgotPassword: {
    title: "Passwort vergessen",
    subtitle: "Setzen Sie Ihr Passwort zurück",
    emailSent: "Email gesendet",
    checkInbox: "Überprüfen Sie Ihren Email-Posteingang",
    emailSentMessage: "Wenn ein Konto mit der Email-Adresse <strong>{email}</strong> existiert, haben wir Ihnen einen Link zum Zurücksetzen des Passworts gesendet.",
    checkSpam: "Bitte überprüfen Sie auch Ihren Spam-Ordner, falls Sie die Email nicht innerhalb weniger Minuten sehen.",
    backToLogin: "Zurück zur Anmeldung",
    enterEmail: "Geben Sie Ihre Email-Adresse ein",
    emailPlaceholder: "ihre@email.com",
    sendResetLink: "Reset-Link senden",
    resetInstructions: "Geben Sie Ihre Email-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  },

  resetPassword: {
    title: "Passwort zurücksetzen",
    subtitle: "Geben Sie Ihr neues Passwort ein",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    resetButton: "Passwort zurücksetzen",
    success: "Passwort erfolgreich geändert!",
    successMessage: "Ihr Passwort wurde geändert. Sie werden zur Anmeldeseite weitergeleitet.",
    invalidToken: "Ungültiger oder abgelaufener Token",
    invalidTokenMessage: "Dieser Reset-Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Passwortreset an.",
    requestNew: "Neuen Reset anfordern",
    verifying: "Reset-Link wird überprüft...",
    passwordMismatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Passwort muss mindestens 8 Zeichen lang sein",
  },

  notFound: {
    title: "404",
    subtitle: "Seite nicht gefunden",
    message: "Entschuldigung, die gesuchte Seite existiert nicht.",
    submessage: "Sie wurde möglicherweise verschoben oder gelöscht.",
    goHome: "Zur Startseite",
  },

  register: {
    title: "Konto erstellen",
    subtitle: "Erstellen Sie Ihr {appTitle}-Konto",
    name: "Vollständiger Name",
    namePlaceholder: "Max Mustermann",
    email: "Email",
    emailPlaceholder: "ihre@email.com",
    password: "Passwort",
    passwordPlaceholder: "Mindestens 8 Zeichen",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Passwort wiederholen",
    registerButton: "Konto erstellen",
    alreadyHaveAccount: "Bereits ein Konto?",
    loginLink: "Hier anmelden",
    accountCreated: "Konto erfolgreich erstellt!",
    accountCreatedPendingActivation: "Registrierung erfolgreich! Ihr Konto muss vom Administrator aktiviert werden, bevor Sie sich anmelden können.",
    registrationFailed: "Registrierung fehlgeschlagen",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Passwort muss mindestens 8 Zeichen lang sein",
  },

  login: {
    title: "Willkommen zurück",
    subtitle: "Melden Sie sich bei Ihrem {appTitle}-Konto an",
    email: "Email",
    emailPlaceholder: "ihre@email.com",
    password: "Passwort",
    passwordPlaceholder: "Ihr Passwort",
    rememberDevice: "Dieses Gerät merken",
    loginButton: "Anmelden",
    forgotPassword: "Passwort vergessen?",
    notRegistered: "Noch nicht registriert?",
    registerLink: "Konto erstellen",
    loginSuccess: "Erfolgreich angemeldet!",
    loginFailed: "Anmeldung fehlgeschlagen",
    invalidCredentials: "E-Mail oder Passwort ist ungültig",
  },

  pdf: {
    project: "Projekt",
    scanOrEnter: "QR-Code scannen oder Code eingeben",
  },

  profile: {
    title: "Profil",
    subtitle: "Verwalten Sie Ihr Profil und Ihre Sicherheitseinstellungen",
    editProfile: "Profil bearbeiten",
    changePassword: "Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    profileUpdated: "Profil erfolgreich aktualisiert!",
    passwordChanged: "Passwort erfolgreich geändert!",
    profileInfo: "Profilinformationen",
    profileInfoDesc: "Aktualisieren Sie Ihren Namen und Ihre Email-Adresse",
    name: "Name",
    email: "Email",
    security: "Sicherheit",
    securityDesc: "Ändern Sie Ihr Passwort",
    oldPassword: "Aktuelles Passwort",
    newPasswordLabel: "Neues Passwort",
    confirmPasswordLabel: "Neues Passwort bestätigen",
    updateProfile: "Profil aktualisieren",
    updatePassword: "Passwort ändern",
    accountInfo: "Kontoinformationen",
    accountDetails: "Details zu Ihrem Konto",
    role: "Rolle",
    roleAdmin: "Administrator",
    roleUser: "Benutzer",
    createdAt: "Erstellt",
    lastLogin: "Letzte Anmeldung",
    logoutSection: "Abmelden",
    logoutDesc: "Melden Sie sich von Ihrem Konto ab",
    logoutButton: "Abmelden",
    errors: {
      profileUpdateFailed: "Profilaktualisierung fehlgeschlagen",
      passwordChangeFailed: "Passwortänderung fehlgeschlagen",
      nameEmailRequired: "Name und Email sind erforderlich",
      allFieldsRequired: "Alle Felder sind erforderlich",
      passwordMismatch: "Neue Passwörter stimmen nicht überein",
      passwordTooShort: "Neues Passwort muss mindestens 8 Zeichen lang sein",
    },
  },

  images: {
    title: "Bilder",
    uploadImages: "Bilder hochladen",
    uploadInProgress: "Upload läuft...",
    dragAndDrop: "Bilder hierher ziehen oder klicken Sie zum Auswählen",
    selectImages: "Bilder auswählen",
    imageCount: "Anzahl Bilder",
    totalSize: "Gesamtgröße",
    setAsAvatar: "Als Avatar setzen",
    avatarSet: "Avatar gesetzt",
    deleteImage: "Bild löschen",
    confirmDeleteImage: "Sind Sie sicher, dass Sie dieses Bild löschen möchten?",
    imageDeleted: "Bild gelöscht",
    imagesUploaded: "Bilder hochgeladen",
    uploadFailed: "Upload fehlgeschlagen",
    noImages: "Keine Bilder",
    uploadFirstImage: "Laden Sie Ihr erstes Bild hoch",
    preview: "Vorschau",
    original: "Original",
    thumbnail: "Vorschaubild",
    dimensions: "Abmessungen",
    fileSize: "Dateigröße",
    uploadedAt: "Hochgeladen",
      gcsNotConfigured: "GCS ist nicht konfiguriert",
      imageNotAvailable: "Bild nicht verfügbar",
      noExifData: "Keine EXIF-Metadaten für dieses Bild verfügbar.",
    downloadError: "Fehler beim Herunterladen des Bildes",
    downloadErrorMultiple: "Fehler beim Herunterladen der Bilder",
    downloadSuccess: "Wird heruntergeladen",
    downloadAllSuccess: "Bilder werden heruntergeladen...",
  },

  theme: {
    toggleDark: "Zu dunklem Theme wechseln",
    toggleLight: "Zu hellem Theme wechseln",
  },

  packages: {
    title: "Pakete",
    description: "Verwalten Sie vordefinierte Pakete für Ihre Kunden",
    createPackage: "Paket erstellen",
    editPackage: "Paket bearbeiten",
    packageName: "Paketname",
    packageDescription: "Beschreibung",
    packagePrice: "Preis",
    isActive: "Aktiv",
    items: "Inhalte",
    addItem: "Inhalt hinzufügen",
    itemType: "Typ",
    itemQuantity: "Anzahl",
    printFormat: "Druckformat",
    digital: "Digitale Bilder",
    print: "Physischer Druck",
    video: "Videos",
    noPackages: "Keine Pakete vorhanden",
    createFirstPackage: "Erstellen Sie Ihr erstes Paket",
    packageCreated: "Paket erstellt",
    packageUpdated: "Paket aktualisiert",
    packageDeleted: "Paket gelöscht",
    deletePackage: "Paket löschen",
    deletePackageConfirm: "Möchten Sie dieses Paket wirklich löschen?",
    printFormatRequired: "Bitte wählen Sie ein Druckformat für jeden Print-Eintrag.",
    packageSelection: "Paket auswählen",
    selectPackage: "Wählen Sie ein Paket",
    manualSelection: "Manuelle Auswahl",
    manualSelectionDescription: "Wählen Sie einzelne Medien ohne Paket",
    packageIncludes: "Paket beinhaltet:",
    digitalImages: "{count} digitale Bilder",
    physicalPrints: "{count}x Druck {format}",
    videos: "{count} Videos",
    selectThisPackage: "Dieses Paket wählen",
    selectedPackage: "Gewähltes Paket",
    packageLimit: "Paketlimit erreicht",
    packageLimitWarning: "Sie haben das Limit für diesen Medientyp erreicht",
    remainingDigital: "Verbleibend: {count} Bilder",
    remainingPrints: "Verbleibend: {count} Drucke",
    remainingVideos: "Verbleibend: {count} Videos",
  },

  accessCodes: {
    title: "Zugangsschlüssel",
    generateCodes: "Schlüssel generieren",
    codesGenerated: "Schlüssel generiert",
    numberOfCodes: "Anzahl der Schlüssel",
    generateCodesDescription: "Geben Sie die Anzahl der zu generierenden Schlüssel ein",
    downloadPDF: "PDF herunterladen",
    pdfGenerated: "PDF generiert",
    code: "Schlüssel",
    usageCount: "Nutzungsanzahl",
    lastUsed: "Zuletzt verwendet",
    invalidated: "Ungültig gemacht",
    invalidate: "Ungültig machen",
    confirmInvalidate: "Möchten Sie diesen Schlüssel wirklich ungültig machen?",
    codeInvalidated: "Schlüssel ungültig gemacht",
    noCodes: "Keine Zugangsschlüssel",
    generateFirstCodes: "Erste Schlüssel generieren",
      active: "Aktiv",
      used: "Verwendet",
    printInstructions: "Drucken oder teilen Sie Zugangsschlüssel mit Ihren Kunden",
    downloadImage: "Als Bild herunterladen",
    imageDownloaded: "QR-Code als Bild heruntergeladen",
  },
};

// Removed invalid type reference to 'en' to avoid TS error